import qweBaseField from "../BaseField"

export default{
    mixins: [qweBaseField],
    data: function () {
        return {
            isSwitch: false
        };
    },
    created:function(){
        this.isSwitch = this.selfSetting.DisplayTypeValue == 1;
    },
    methods:{
        setValueBeforeHook:function (value) {
            if (value == undefined || value == null) {
                return null;
            }
            else {
                return Boolean(value);
            }
        },
    }
}